import { useState, useEffect, useRef } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

import {
  Toolbar,
  Link,
  AppBar,
  Typography,
  IconButton,
  Box,
  ClickAwayListener,
  Paper,
  Grow,
  Popper,
  Button,
  MenuItem,
  MenuList,
  Container,
  Avatar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import { useDispatch, useSelector } from "react-redux";
import { toggleNavDrawer } from "../../redux/actions/layout";

import { handleWebsiteAddress } from "../../utility/utils";
import Cookies from "js-cookie";

const Header = ({ styles }) => {
  const { profile, config } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { search } = useLocation();
  let query = new URLSearchParams(search);

  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const anchorRef = useRef(null);

  const websiteAddress = handleWebsiteAddress();

  // Logic functions
  const toggleNav = () => dispatch(toggleNavDrawer());
  const toggleProfileMenu = () => {
    setIsProfileMenuOpen((prev) => !prev);
  };
  const closeProfileMenu = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setIsProfileMenuOpen(false);
  };
  const handleProfileData = () => {
    switch (config.Panel) {
      case "Agency":
        return {
          name: profile.shippingProfile?.name,
          avatar: profile.avatar,
        };

      default:
        return {
          name: `${profile.fname || ""} ${profile.lname || ""}`,
          avatar: profile.avatar,
        };
    }
  };

  const profileData = handleProfileData();

  const prevOpen = useRef(isProfileMenuOpen);
  var showFromApp = query.get("from") === "app";
  let from = localStorage.getItem("from");
  let agent_service = localStorage.getItem("agent_service");

  if (
    (from && from === "app") ||
    (agent_service &&
      (agent_service === "shahrzad" || agent_service === "splus")) ||
    Cookies.get("token") === undefined
  ) {
    showFromApp = true;
  } else if (query.get("from") === "app") {
    localStorage.setItem("from", "app");
  }
  useEffect(() => {
    if (prevOpen.current === true && isProfileMenuOpen === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = isProfileMenuOpen;
  }, [isProfileMenuOpen]);

  return (
    <>
      <Box sx={{ flexGrow: 1 }}>
        {!showFromApp && (
          <AppBar
            position="static"
            className={styles}
            sx={{ bgcolor: "primary.main" }}
          >
            <Container maxWidth="xl" sx={{ height: "100%" }} disableGutters>
              <Toolbar
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                    onClick={toggleNav}
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                  >
                    <MenuIcon fontSize="large" />
                  </IconButton>
                  <Link component={RouterLink} to="/">
                    <img
                      src={config.PanelLogoWhite}
                      alt="Logo"
                      style={{ display: "block", height: "40px" }}
                    />
                  </Link>
                </Box>

                <Box
                  sx={{
                    display: { xs: "none", md: "flex" },

                    "& a": {
                      mx: 2,
                      transition: "all .3s",
                      color: "inherit",
                      textDecoration: "none",

                      "&:hover": { color: "secondary.main" },
                    },
                  }}
                >
                  {config.HeaderNavItems?.map((item) => {
                    return item.websiteAddress ? (
                      <Link href={websiteAddress + item.link} key={item.link}>
                        {item.name}
                      </Link>
                    ) : item.externalLink ? (
                      <a href={item.link} key={item.link}>
                        {item.name}
                      </a>
                    ) : (
                      <Link
                        component={RouterLink}
                        to={item.link}
                        key={item.link}
                      >
                        {item.name}
                      </Link>
                    );
                  })}
                </Box>

                <Button
                  ref={anchorRef}
                  aria-controls={
                    isProfileMenuOpen ? "header-profile" : undefined
                  }
                  aria-haspopup="true"
                  onClick={toggleProfileMenu}
                  variant="text"
                  color="inherit"
                  sx={{
                    display: { xs: "none", md: "flex" },
                  }}
                >
                  <Typography variant="subtitle2">
                    {profileData?.name || "-"}
                  </Typography>
                  <Avatar
                    src={profileData.avatar}
                    sx={{ width: "50px", height: "50px", ml: "10px" }}
                  />
                </Button>
                <Popper
                  open={isProfileMenuOpen}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                  style={{ zIndex: 1000 }}
                >
                  {({ TransitionProps }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin: "center bottom",
                      }}
                    >
                      <Paper sx={{ width: "150px" }} elevation={5}>
                        <ClickAwayListener onClickAway={closeProfileMenu}>
                          <MenuList
                            autoFocusItem={isProfileMenuOpen}
                            id="header-profile"
                          >
                            <MenuItem
                              onClick={closeProfileMenu}
                              component={RouterLink}
                              to="/profile"
                            >
                              پروفایل
                            </MenuItem>
                            <MenuItem
                              onClick={closeProfileMenu}
                              component={RouterLink}
                              to="/logout"
                            >
                              خروج
                            </MenuItem>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Toolbar>
            </Container>
          </AppBar>
        )}
      </Box>
    </>
  );
};

export default Header;
